import React from 'react';
import PropTypes from 'prop-types';

const AdjustItemMpTableRow = ({itemMp}) => {
  if(itemMp.Values.length > 1){
    return <tr>
      <td style={{ width: '28%' }}>
        <p className="mb-0"><strong>{itemMp.ItemMpText || <span>&nbsp;</span>}</strong></p>
        {itemMp.Values.map((itemMpValue, key) => <p className="mb-0" key={key.toString()}>{itemMpValue.QualColText || <span>&nbsp;</span>}</p>)}
      </td>
      <td>
        <p className="mb-0">&nbsp;</p>
        {itemMp.Values.map((itemMpValue, key) => <p className="mb-0" key={key.toString()}>{itemMpValue.ValueText || <span>&nbsp;</span>}</p>)}
      </td>
      <td>
        <p className="mb-0">&nbsp;</p>
        {itemMp.Values.map((itemMpValue, key) => <p className="mb-0" key={key.toString()}>{itemMpValue.AdditionalText || <span>&nbsp;</span>}</p>)}
      </td>
    </tr>
  }else{
    return <tr>
      <td>{itemMp.ItemMpText}</td>
      <td>{itemMp.Values[0].ValueText}</td>
      <td>{itemMp.Values[0].AdditionalText}</td>
    </tr>
  }};

AdjustItemMpTableRow.propTypes = {
  itemMp: PropTypes.shape({
    Values: PropTypes.arrayOf(PropTypes.shape({

    }),),
  }).isRequired,
};

export default AdjustItemMpTableRow;